import React from 'react';

function ServicesHero() {
  return (
    <section className="services-hero" style={{ backgroundImage: "url('/assets/images/nextgen-banner-3-2e75e618f6d4de358c0e381e1fb14b1a-1.webp')" }}>
      {/* Overlay to dim background and match reference photo color scheme */}
      <div className="services-hero-overlay"></div>

      {/* Services Hero Content */}
      <div className="container services-hero-container">
        <div className="services-hero-content">
          <div className="services-hero-tagline-row">
            <span className="services-hero-tagline">Our Services</span>
            <div className="services-hero-tagline-line"></div>
          </div>
          <h1 className="services-hero-title">
            Let's Start Your Success Journey With Our Experts
          </h1>
          <p className="services-hero-description">
            Experience superior customer support through our call center services—efficient inbound/outbound calls, order processing, and reliable technical assistance. Streamlined communication for satisfaction.
          </p>
        </div>
      </div>
    </section>
  );
}

export default ServicesHero;
